import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { deleteRole, RolesCollection } from "@tKgpco/Services/SecurityRolesService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import searchFilterSecurityRoles from "@tKgpco/Store/Data/SecurityRoles/Handlers/SearchFilterRoles";

type Parameters = { id: string } & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, RolesCollection>;

export const BeginDeleteRole: HandlerType = props => {
    props.dispatch({ type: "Custom/SecurityRoles/ShowOverlay" });
};

export const RequestDataFromApi: HandlerType = async props => {
    return deleteRole(props.parameter.id);
};

export const LoadSecurityRoles: HandlerType = props => {
    props.dispatch(searchFilterSecurityRoles({ page: 1 }));
};

export const CompleteDeleteRole: HandlerType = props => {
    props.dispatch({
        type: "Custom/SecurityRoles/HideOverlay",
    });
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [BeginDeleteRole, RequestDataFromApi, LoadSecurityRoles, CompleteDeleteRole, ExecuteOnSuccess];

const removeRole = createHandlerChainRunner(chain, "removeRole");
export default removeRole;
